import React from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { CATEGORIES } from '../../constants/analytics.json'
import events, { Event } from 'pubsub/events'
import getSubdomain from '../../utils/getSubdomain'

import MedicareLogo from '../MedicareLogo/MedicareLogo'
import { GovBanner } from '../GovBanner/GovBanner'

export interface GovAndMenuWrapperProps {
  languageToggleLink: string;
  children: React.ReactNode;
  isLoggedIn: boolean;
}

export const GovAndMenuWrapper: React.FC<GovAndMenuWrapperProps> = ({ children, languageToggleLink, isLoggedIn }) => {
  const { i18n } = useTranslation()
  const lang = (i18n.language === 'es') ? 'es' : 'en'

  const ignoredSubdomain = lang === 'es' ? 'www' : undefined
  const medicareEnv = process.env.REACT_APP_MEDICARE_ENV || ''
  const medicareSubdomain = getSubdomain(medicareEnv, ignoredSubdomain)
  const langSubdomain = getSubdomain(lang, 'en')

  const medicareUrl = `https://${langSubdomain + medicareSubdomain}medicare.gov`

  const medicareLogoClickEventOptions: Event = {
    text: 'Medicare.gov',
    authenticated: isLoggedIn,
    targetLocation: medicareUrl,
    category: CATEGORIES.LOGO,
    activity: 'Link Click',
    url: window.location.href,
    language: i18n.language,
    title: document.title,
    sendToTealium: true,
    sendToCoreAPI: true,
    isMessageCenter: false
  }

  const mainWrapperClass = classNames('ch-c-header',
    { 'language-es': i18n.language === 'es' },
    { 'language-en': i18n.language === 'en' })

  return (
    <header>
      <GovBanner languageToggleLink={languageToggleLink} isLoggedIn={isLoggedIn} />
      <div className={mainWrapperClass}>
        <a
          className='nav-menu-button ch-c-medicare-logo-wrapper'
          href={medicareUrl}
          onClick={() => events.publish(medicareLogoClickEventOptions)}
        >
          <MedicareLogo />
        </a>
        <div className='ch-c-header__navigation-container'>
          {children}
        </div>
      </div>
    </header>
  )
}
